import { useCallback, useEffect, useState } from 'react'

export default function useOnboardingVisibility(storageKey) {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    // Debug: ?showOnboarding=1 or ?showOnboarding=true (URL and/or sessionStorage — see main.jsx capture).
    // SessionStorage is set on first load so onboarding still applies after ?tab= sync or when the Shop
    // panel mounts later (GrocerySearch is not mounted on other tabs).
    try {
      const params = new URLSearchParams(window.location.search)
      const showOnboarding = params.get('showOnboarding')
      if (showOnboarding === '1' || showOnboarding === 'true') {
        setIsVisible(true)
        return
      }
    } catch {
      // Fall through.
    }

    try {
      if (sessionStorage.getItem('debug_show_onboarding') === '1') {
        setIsVisible(true)
        return
      }
    } catch {
      // Fall through.
    }

    try {
      const hasSeen = localStorage.getItem(storageKey) === '1'
      setIsVisible(!hasSeen)
    } catch {
      setIsVisible(true)
    }
  }, [storageKey])

  const dismiss = useCallback(() => {
    try {
      sessionStorage.removeItem('debug_show_onboarding')
    } catch {
      // ignore
    }
    try {
      localStorage.setItem(storageKey, '1')
    } catch {
      // Ignore storage errors and keep in-memory dismissal.
    }
    setIsVisible(false)
  }, [storageKey])

  return { isVisible, dismiss }
}
